/**
 * Product Selector PDF genertor NOT ERP, that is a seperate application
 * https://printmaker.docs.topshelfcraft.com
 */

import $ from 'jquery';

// Module options
const options = {};

// Cached elements
const $el = {};

// Module events
export default function init() {
	bindEvents();
}

// User interactions go here
function bindEvents() {
	
	// This works
	$('.js-email-test').on('click', function(e) {
		e.preventDefault();

		$.ajax({
			url: '/pdf/email', type: 'GET',
		}).done(function(response) {
			console.log('success');
		}).fail(function() {
			console.log('error');
		}).always(function() {
			console.log('complete');
		});

	});
	
	// This should work but doesn't
	$('.js-print-test').on('click', function(e) {
		e.preventDefault();

		const pdfUrl = $(this).attr('href');

		$('#print-label-frame').contents().find('#pdfDocument').attr('src', pdfUrl);
		$('#print-label-frame').contents().find('#test').html('<h2>GENERATED CONTENT</h2>');

		setTimeout(() => {
			$('#print-label-frame').get(0).contentWindow.focus();
			$('#print-label-frame').get(0).contentWindow.print();
		}, 3000);

	});

	// This doesn't work
	$('.js-download-test').on('click', function(e) {
		e.preventDefault();

		const pdfUrl = $(this).attr('href');

		$.ajax({
			url: pdfUrl, type: 'POST',
			dataType: 'html',
			data: {
				firstName: 'Warehouse',
				lastName: 'Six'
			}
		}).done(function(data) {
			console.log('success');
			$('#firstName').text(data.firstName)
			$('#lastName').text(data.lastName)
			
		}).fail(function() {
			console.log('error');
		}).always(function() {
			console.log('complete');
		});

	});

}

export function resize() {}

export function scroll() {}

export function aria() {}